<template>
<!-- 首页-5张叠加照片轮播图 -->
  <div class="five_swiper d-f f-ai-c f-jc-c">
    <transition name="fade">
      <div class="swiper">
        <div
          @click="chooseItem(item, index)"
          v-for="(item, index) in imgs"
          :style="config5[index]"
          :key="item.cover"
        > 
          <div class="bg_box" style="width: 100%; height: 100%">
            <div class="fixed_box" :style="{
            background: config5[index].id =='center' ? '':
            (config5[index].id == 'A'|| config5[index].id =='E') ? 'rgba(0, 160, 233, 0.8)':
            (config5[index].id == 'B'|| config5[index].id =='D') ? 'rgba(171, 205, 2, 0.6)':''}"></div>
            <img class="bor_r" :src="item.cover" style="width: 100%; height: 100%" />
          </div>
        </div>
      </div>
    </transition>

    <div class="icon_box d-f f-ai-c f-jc-sb">
      <!-- <div class="chang_icon d-f f-ai-c f-jc-c c-p" :class="currentIndex == 1 ?'chang_icon_disable':''" @click="currentIndex != 1 ? prev() :''"> -->
      <div class="chang_icon d-f f-ai-c f-jc-c c-p" @click="prev()">
        <i class="el-icon-arrow-left"></i>
      </div>
      <!-- <div class="chang_icon d-f f-ai-c f-jc-c c-p" :class="currentIndex == 0 ?'chang_icon_disable':''" @click="currentIndex != 0 ? next():''"> -->
      <div class="chang_icon d-f f-ai-c f-jc-c c-p" @click="next()">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "zt",
  data() {
    return {
      loading: true,
      currentIndex: 3, //当前中间imgs数组中index
      // centerInfo: "", // 当前中间信息
      startX: "",
      endX: "",
      imgs: [
        {
          index: 0,
          // cover: require('@/assets/images/index/banner5.png'),
          background: 'rgba(0, 160, 233, 0.8)'
        },
        {
          index: 1,
          // cover: require('@/assets/images/index/banner2.png'),
          background: 'rgba(171, 205, 2, 0.6)'
        },
        {
          index: 2,
          // cover: require('@/assets/images/index/banner1.png'),
          background: '',
        },
        {
          index: 3,
          // cover: require('@/assets/images/index/banner3.png'),
          background: 'rgba(171, 205, 2, 0.6)'
        },
        {
          index: 4,
          // cover: require('@/assets/images/index/banner4.png'),
          background: 'rgba(0, 160, 233, 0.8)'
        },
        // {
        //   index: 5,
        //   cover: require('@/assets/images/index/bgc1.png')
        // },
        // {
        //   index: 6,
        //   cover: require('@/assets/images/index/bgc2.png')
        // },
      ],
      // previous: 0,
      config5: [
        // {
        //   id: '-A',
        //   position: "absolute",
        //   width: "14.2188vw",
        //   height: "15.625vw",
        //   top: "6.5104vw",
        //   left: "-12vw",
        //   opacity: 1,
        //   zIndex: 1,
        //   transition: ".4s",
        // },
        {
          id: "A",
          position: "absolute",
          width: "20.8333vw",
          height: "15.625vw",
          top: "6.5104vw",
          left: "0vw",
          opacity: 1,
          zIndex: 1,
          transition: ".4s",
          // backgroundColor: 'rgba(0, 160, 233, 0.8)'
        },
        {
          id: "B",
          position: "absolute",
          width: "26.0417vw",
          height: "19.5313vw", 
          top: "4.5833vw",
          left: "6.4062vw",
          opacity: 1,
          zIndex: 2,
          transition: ".4s",
          // backgroundColor: 'rgba(171, 205, 2, 0.6)'
        },
        {
          id: "center",
          position: "absolute",
          width: '38.3333vw',
          height: "28.6458vw",
          top: "0vw",
          left: "27.3438vw",
          marginLeft: "-14.2188vw",
          opacity: 1,
          zIndex: 4,
          transition: ".4s"
        },
        {
          id: "D",
          position: "absolute",
          width: "26.0417vw",
          height: "19.5313vw", 
          top: "4.5833vw",
          right: '6.4062vw',
          opacity: 1,
          zIndex: 2,
          transition: ".4s",
        },
        {
          id: "E",
          position: "absolute",
          width: "20.8333vw",
          height: "15.625vw",
          top: "6.5104vw",
          right: "0vw",
          opacity: 1,
          zIndex: 1,
          transition: ".4s",
        },
        // {
        //   id: 'E+',
        //   position: "absolute",
        //   width: "14.2188vw",
        //   height: "15.625vw",
        //   top: "6.5104vw",
        //   right: "-22vw",
        //   opacity: 1,
        //   zIndex: 1,
        //   transition: ".4s",
        // }
      ],
    };
  },
  created() {
    this.getData();
    // this.addCardStyle(); // 加入样式位置的index
  },
  methods: {
    // 获取数据
    async getData() {
      this.$nextTick(() => {
        this.loading = false;
      });
    },
    // 滑动上一个
    prev(index) {
      // this.imgs.unshift(this.imgs.pop());
      this.config5.push(this.config5.shift());
      this.currentIndex = this.currentIndex - 1;
      if (this.currentIndex < 0) {
        this.currentIndex = this.imgs.length - 1;
      }
      this.centerIndex("prev");
    },
    // 滑动下一个
    next() {
      // this.imgs.push(this.imgs.shift());
      this.config5.unshift(this.config5.pop());
      this.currentIndex = this.currentIndex + 1;
      if (this.currentIndex > this.imgs.length - 1) {
        this.currentIndex = 0;
      }
      this.centerIndex("next");
    },
    formatSwiper() {
      if (this.startX > this.endX) {
        // console.log("左边滑动");
        if (this.startX > this.endX + 40) {
          this.next();
        }
      } else {
        // console.log("右边滑动");
        if (this.endX > this.startX + 40) {
          this.prev();
        }
      }
    },
    // 阻止touchmove的横向默认事件（ios快捷操作会关闭页面）
    stopDefault(event) {
      let differenceY = this.endY - this.startY;
      let differenceX = this.endX - this.startX;
      if (Math.abs(differenceX) > Math.abs(differenceY)) {
        event.preventDefault();
      }
    },
    // 当前imgs在位置上的index（并非img数组的index）
    centerIndex(val) {
      if (val == "prev") {
        for (let val of this.imgs) {
          if (val.index == this.imgs.length - 1) {
            val.index = 0;
          } else {
            val.index = val.index + 1;
          }
        }
      } else {
        for (let val of this.imgs) {
          if (val.index == 0) {
            val.index = this.imgs.length - 1;
          } else {
            val.index = val.index - 1;
          }
        }
      }
    },
    // // 点击
    chooseItem(item, index) {
    //   // console.log(item);
    //   let cycles = item.index;
    //   if (item.index < 3) {
    //     for (let i = 0; i < 3 - cycles; i++) {
    //       this.prev();
    //     }
    //   } else if (item.index > 3) {
    //     for (let i = -1; i < item.index - 3; i++) {
    //       this.next();
    //     }
    //   } 
    //   // else if (item.index == 3) {
        
    //   // }
    },

  //   addCardStyle() {
  //     if (this.imgs.length > 7) {
  //       let addtime = this.imgs.length - 7;
  //       for (let i = 0; i < addtime; i++) {
  //         console.log("add");
  //         this.config5.push({
  //           id: "center",
  //           position: "absolute",
  //           width: "45%",
  //           height: "100%",
  //           top: "0vw",
  //           left: "50%",
  //           marginLeft: "-22.5%",
  //           opacity: 0,
  //           transition: ".1s",
  //         });
  //       }
  //     }
  //   },
  },
};
</script>

<style  scoped>
.five_swiper {
  width: 100%;
  height: 100%;
  position: relative;
}
.swiper {
  width: 64.5833vw;
  height: 28.6458vw;
  position: relative;
  overflow: hidden;
}
/* .swiper div {
  opacity: 0;
} */

.bg_box {
  /* opacity: 1 !important; */
  position: relative;
}
.fixed_box {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 0.5208vw;
}

.bor_r {
  border-radius: 0.5208vw;
}

.icon_box {
  width: 76vw;
  height: 3.125vw;
  position: absolute;
  transform: translateY(50%, -50%);
}

.chang_icon {
  width: 3.3333vw;
  height: 3.3333vw;
  background: rgb(195, 219, 73);
  border-radius: 50%;
  color: #fff;
}
.chang_icon i {
  font-size: 1.6667vw;
}
.chang_icon_disable {
  background: rgb(223, 223, 223);
}
</style>